export const STRING_EMPTY = '<remove>'
export const NUMBER_EMPTY = -99999
